import * as React from "react";
import { Button, Stack, TextField } from "@mui/material";
import InputControl from "../../../shared/components/InputControl";
import SimpleReactValidator from "simple-react-validator";
import { LoadingButton } from "../../../shared";

export const AddOrEditAddress = (props) => {

  const {
    state,
    onChange,
    handleClose,
    onCreateAddress,
    onUpdateAddress,
    globalData,
  } = props

  const { updateData: { name, address, email, phone, country_code }, isSaveButton, isModalType } = state;

  const [, forceUpdate] = React.useState();
  const validator = React.useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
    })
  );

  const onSubmit = () => {
    if (validator.current.allValid()) {
      isModalType === "add" ? onCreateAddress() : onUpdateAddress()
    } else {
      validator.current.showMessages();
      forceUpdate(1);
    }
  };



  return (
    <Stack
      sx={{
        gap: "16px",
        mt: "16px"
      }}
    >
      <InputControl
        name="name"
        label="Name *"
        sx={{
          width: "100%",
          bgcolor: "#fff",
        }}
        value={name}
        onChange={onChange}
        error={validator.current.message("Name", name, "required")}
        helperText={validator.current.message("Name", name, "required")}
      />
      <InputControl
        type="textarea"
        name="address"
        label="Address*"
        rows={2}
        value={address}
        onChange={onChange}
        error={validator.current.message("Address", address, "required")}
        helperText={validator.current.message("Address", address, "required")}
      />

      <InputControl
        name="email"
        label="Email Id*"
        sx={{
          width: "100%",
          bgcolor: "#fff",
        }}
        onChange={onChange}
        value={email}
        error={validator.current.message("Email Id", email, "required|email")}
        helperText={validator.current.message("Email Id ", email, "required|email")}
      />
      <Stack direction="row" gap="20px">
        <InputControl
          type="dropdown"
          id="country_code"
          disableClearable
          options={globalData.country_codes ?? []}
          getOptionLabel={(option) => option.label}
          value={
            globalData?.country_codes?.length > 0 && country_code
              ? globalData?.country_codes?.find(
                (c) => c.value === country_code
              )
              : null
          }
          onChange={(e, newValue) => {
            onChange({
              target: {
                name: "country_code",
                value: newValue.value,
              },
            });
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Country code"
              required
              error={validator.current.message(
                "Country Code",
                country_code,
                "required"
              )}
              helperText={validator.current.message(
                "Country Code",
                country_code,
                "required"
              )}
            />
          )}
        />

        <InputControl
          name="phone"
          type="number"
          label="Phone Number*"
          sx={{
            width: "100%",
            bgcolor: "#fff",
          }}
          onChange={onChange}
          value={phone}
          error={validator.current.message(
            "Phone Number",
            phone,
            "required|numeric|size:10"
          )}
          helperText={validator.current.message(
            "Phone Number",
            phone,
            "required|numeric|size:10"
          )}
        />
      </Stack>
      <Stack direction="row" gap="16px" justifyContent="flex-end">
        <Button
          variant="outlined"
          sx={{
            border: "none",
            "&:hover": {
              border: "none",
            },
          }}
          onClick={handleClose}
        >
          Cancel
        </Button>
        <LoadingButton
          type="button"
          variant="contained"
          onClick={onSubmit}
          loading={isSaveButton}
        >
          {isModalType === "add" ? "Save" : "Update"}
        </LoadingButton>
      </Stack>
    </Stack>
  );
};
